import { featuresData, securityBadgesData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            为什么选择91官网？
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            作为官方认证的91平台入口，我们为您提供全方位的安全保障和优质服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 hover:bg-primary-50/20 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-4 md:gap-6">
          {securityBadgesData.map((badge) => (
            <div
              key={badge.id}
              className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-accent-50 border border-accent-200/60"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-sm text-accent-600`}></i>
              </div>
              <span className="text-xs font-medium text-accent-800 whitespace-nowrap">{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}